module.exports = __webpack_public_path__ + "media/images/landing/second_2x/photo21-f9b70c5348c10b3bafd52e364963c51e.jpg";